import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import AppLayout from "@/pages/AppLayout";
import Projects from "@/pages/Projects";
import NewApp from "@/pages/NewApp";
import Published from "@/pages/Published";
import Credits from "@/pages/Credits";
import Usage from "@/pages/Usage";
import Plan from "@/pages/Plan";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Support from "@/pages/Support";
import Admin from "@/pages/Admin";
import Workspace from "@/pages/Workspace";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import PublicApp from "@/pages/PublicApp";
import { Loader2 } from "lucide-react";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-cyan-400" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/p/:slug" element={<PublicApp />} />
          <Route path="/pago/exito" element={<Protected><PaymentSuccess /></Protected>} />
          <Route path="/pago/cancelado" element={<Protected><PaymentCancel /></Protected>} />
          <Route path="/app/proyecto/:id" element={<Protected><Workspace /></Protected>} />
          <Route path="/app" element={<Protected><AppLayout /></Protected>}>
            <Route index element={<Projects />} />
            <Route path="nuevo" element={<NewApp />} />
            <Route path="publicadas" element={<Published />} />
            <Route path="creditos" element={<Credits />} />
            <Route path="consumo" element={<Usage />} />
            <Route path="plan" element={<Plan />} />
            <Route path="facturacion" element={<Billing />} />
            <Route path="configuracion" element={<Settings />} />
            <Route path="soporte" element={<Support />} />
            <Route path="admin" element={<Protected admin><Admin /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </AuthProvider>
  );
}
